$(function(){
    if($('.b-old-browser').length < 1) {
        return;
    }
    var $context = $('.b-old-browser'),
        $close = $('.b-old-browser__close', $context);

    $close.on('click', function(){
        $context.hide();
    })
});